import React, { Component } from "react";
import { ajaxManage } from "utils/common";
import { Table, Divider, message } from 'antd';

const { Column } = Table;

function App(props) {
	const { pageData, pagination, handleTableChange, deleteAccountById } = props;

	return (
		<Table dataSource={pageData}
			pagination={pagination}
			onChange={handleTableChange}
			rowKey={record => record.id}
			className="list-table"
		>
		    <Column
	        	title="id"
	        	dataIndex="id"
	      	/>
		    <Column
	        	title="真实姓名"
	        	dataIndex="realName"
	      	/>
		    <Column
		      	title="openId"
		      	dataIndex="openId"
		    />
	    	<Column
		      	title="操作"
		      	dataIndex="operate"
		      	render={(text, record) => 
		        	<a href="javascript:;" onClick={() => deleteAccountById(record.id)}>删除</a>
	        	}
		    />
	  	</Table>
	);
}

export default App;